
import styles from '../style.module.css';
import useCountUp from "../hooks/useCountUp";

function AdvantagesItem({ value, title, text, textColor = 'black', background = 'white', startAnimation }) {

    const number = useCountUp(value, startAnimation);

    const suffix = value.replace(/[0-9]/g, '');


    return (
        <div
            className={styles.advantages_item}
            style = {{ background: `${background}` }}
        >
            <span style={{ color: `${textColor}` }}>
                {number}
                {suffix}
            </span>
            <span style={{ color: `${textColor}` }}>
                { title }
            </span>
            <span style={{ color: background !== 'white' && `#FFFFFF` }}>
                { text }
            </span>
        </div>
    )
}

export default AdvantagesItem